(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('LenderContactDeleteController',LenderContactDeleteController);

    LenderContactDeleteController.$inject = ['$uibModalInstance', 'entity', 'LenderContact'];

    function LenderContactDeleteController($uibModalInstance, entity, LenderContact) {
        var vm = this;

        vm.lenderContact = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            LenderContact.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
